<div>
  <div *ngIf="loading" class="history-spinner-container">
    <mat-spinner class="mt-4" diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!loading && errorMessage" class="no-result-row">
    {{ errorMessage | translate }}
  </div>
  <div *ngIf="!loading && !errorMessage && !hasSearched && searchResults.length === 0" class="no-result-row">
    {{ 'dimbo.i18n.submissionHistory.defaultSearch.message' | translate }}
  </div>
  <!-- Vehicle history in accordions -->
  <mat-accordion *ngIf="!loading && !errorMessage" class="vehicle-history-accordion">
    <!-- Start: CAP-39922 DMBR-64 -->
    <mat-expansion-panel *ngFor="let contract of displayContracts; let i = index" #filterPanel>
    <!-- End: CAP-39922 DMBR-64 -->
      <mat-expansion-panel-header>
        <!-- Start: CAP-39922 DMBR-64 -->
        <!-- Filter search: two-row layout (only for non-VIN search by central users or non-submissionMode) -->
        <div class="panel-header panel-header-filter" *ngIf="!isVinSearch && !(submissionMode && !isCentralUser)">
        <!-- End: CAP-39922 DMBR-64 -->
          <!-- Row 1: Date | Brand+Model | (empty) | VIN | (empty) -->
          <div class="filter-row-top">
            <div class="grid-item">
              <div>{{ contract.submissionTimestamp | date: 'dd/MM/yyyy' }}</div>
            </div>
            <div class="grid-item">
              <span>{{ getFullBrandName(contract.vinBrand) }} {{ contract.model }}</span>
            </div>
            <div class="grid-item"></div>
            <div class="grid-item">
              <span>{{ contract.vin }}</span>
            </div>
            <div class="grid-item"></div>
          </div>
          <!-- Start: CAP-39922 DMBR-64 -->
          <!-- Row 2: shown always (expanded and collapsed) -->
          <div class="filter-row-bottom">
            <div class="grid-item"></div>
            <div class="grid-item vehicle-info">
              <div class="info-row">
                <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.vehicleMileage' | translate }}</span>
                <span class="info-value">{{ contract.mileage }} <span *ngIf="contract.mileageUnit?.toLowerCase() === 'mi'; else kmUnitFilter">
                  {{ 'dimbo.i18n.brandcareForm.unit.mi' | translate }}
                </span>
                <ng-template #kmUnitFilter>
                  {{ 'dimbo.i18n.brandcareForm.unit.km' | translate }}
                </ng-template></span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.vehicleAge' | translate }}</span>
                <span class="info-value">{{ contract.vehicleAge }}&nbsp;{{ contract.vehicleAge == 1 ? ('dimbo.i18n.brandcareForm.unit.month' | translate) : ('dimbo.i18n.brandcareForm.unit.months' | translate) }}</span>
              </div>
            </div>
            <div class="grid-item"></div>
            <div class="grid-item vehicle-info">
              <div class="info-row">
                <span class="info-label">{{ 'dimbo.i18n.brandcareForm.history.userId' | translate }}</span>
                <span class="info-value">{{ contract.userId }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ 'dimbo.i18n.brandcareForm.history.associatedRepairerId' | translate }}</span>
                <span class="info-value">{{ contract.vinRrdi }}</span>
              </div>
            </div>
            <div class="grid-item"></div>
          </div>
        </div>

        <!-- Start: CAP-39922 DMBR-64 -->
        <!-- VIN search or submissionMode repairer: single-row layout -->
        <div class="panel-header grid-container" *ngIf="isVinSearch || (submissionMode && !isCentralUser)">
        <!-- End: CAP-39922 DMBR-64 -->
        <!-- End: CAP-39922 DMBR-64 -->
          <!-- Date of issue -->
          <div class="grid-item">
            <!-- Start: CAP-39922 DMBR-64 -->
            <div>{{ contract.submissionTimestamp | date: 'dd/MM/yyyy' }}</div>
            <!-- End: CAP-39922 DMBR-64 -->
          </div>

          <!-- Vehicle mileage and age -->
          <div class="grid-item vehicle-info">
            <div class="info-row">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.vehicleMileage' | translate }}</span>
              <span class="info-value">{{ contract.mileage }} <span *ngIf="contract.mileageUnit?.toLowerCase() === 'mi'; else kmUnit">
                {{ 'dimbo.i18n.brandcareForm.unit.mi' | translate }}
              </span>
              <ng-template #kmUnit>
                {{ 'dimbo.i18n.brandcareForm.unit.km' | translate }}
              </ng-template></span>
            </div>
            <div class="info-row">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.vehicleAge' | translate }}</span>
              <span class="info-value">{{ contract.vehicleAge }}&nbsp;{{ contract.vehicleAge == 1 ? ('dimbo.i18n.brandcareForm.unit.month' | translate) : ('dimbo.i18n.brandcareForm.unit.months' | translate) }}</span>
            </div>
          </div>

          <div class="grid-item"></div>
          <!-- User ID and Repairer ID -->
          <div class="grid-item vehicle-info">
            <div class="info-row">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.history.userId' | translate }}</span>
              <span class="info-value">{{ contract.userId }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.history.associatedRepairerId' | translate }}</span>
              <span class="info-value">{{ contract.vinRrdi }}</span>
            </div>
          </div>

          <!-- Current Contract Badge (VIN search only) -->
          <div class="grid-item" *ngIf="contract.isCurrentContract">
            <span class="contract-status">{{ 'dimbo.i18n.brandcareForm.history.currentContract' | translate }}</span>
          </div>
        </div>
      </mat-expansion-panel-header>

      <!-- Expanded panel details -->
      <div class="panel-details">
        <mat-divider></mat-divider>
        <!-- First block -->
        <div class="grid-container-first-block">
          <div class="grid-item">
            <div class="in-column-value">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.conditionsOfUse' | translate }}</span>
              <span class="info-value">{{ contract.conditionOfUse }}</span>
            </div>
          </div>
          <div class="grid-item">
            <div class="in-column-value">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.reference' | translate }}</span>
              <span class="info-value">{{ contract.workLineOperationCode }}</span>
            </div>
          </div>
          <div class="grid-item">
            <div class="in-column-value">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.typeOfService' | translate }}</span>
              <span class="info-value">{{ contract.workLineLabel }}</span>
            </div>
          </div>
          <div class="grid-item">
            <div class="in-column-value">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.maintenanceFrequency' | translate }}</span>
              <span class="info-value">{{ contract.maintenanceFrequency }}</span>
            </div>
          </div>
        </div>
        <mat-divider *ngIf="contract.pnrFolderId && contract.dmsFolderId"></mat-divider>
        <!-- Second block -->
        <div class="grid-container-second-block" *ngIf="contract.pnrFolderId && contract.dmsFolderId">
          <div class="grid-item">
            <div [ngClass]="isMobile || isTablet ? 'in-column-value' : 'in-row-value'">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.panierFolderId' | translate }}</span>
              <span class="info-value">{{ contract.pnrFolderId }}</span>
            </div>
          </div>
          <div class="grid-item">
            <div [ngClass]="isMobile || isTablet ? 'in-column-value' : 'in-row-value'">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.label.dmsFolderId' | translate }}</span>
              <span class="info-value">{{ contract.dmsFolderId }}</span>
            </div>
          </div>
        </div>

        <mat-divider></mat-divider>
        <!-- Third block -->
        <div class="grid-container-third-block">
          <div class="grid-item">
            <div [ngClass]="isMobile || isTablet ? 'in-column-value' : 'in-row-value'">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.history.contractNumber' | translate }}</span>
              <span class="info-value">{{ contract.cemContractId }}</span>
            </div>
          </div>
          <div *ngIf="!isMobile && !isTablet" class="grid-item"></div>
          <div class="grid-item">
            <div [ngClass]="isMobile || isTablet ? 'in-column-value' : 'in-row-value'">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.history.issueDate' | translate }}</span>
              <!-- Start: CAP-39922 DMBR-64 -->
              <span class="info-value">{{ contract.cemContractStartDate | date: 'dd/MM/yyyy' }}</span>
              <!-- End: CAP-39922 DMBR-64 -->
            </div>
          </div>
          <div class="grid-item">
            <div [ngClass]="isMobile || isTablet ? 'in-column-value' : 'in-row-value'">
              <span class="info-label">{{ 'dimbo.i18n.brandcareForm.history.expirationDate' | translate }}</span>
              <!-- Start: CAP-39922 DMBR-64 -->
              <span class="info-value">{{ contract.cemContractExpirationDate | date: 'dd/MM/yyyy' }}</span>
              <!-- End: CAP-39922 DMBR-64 -->
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
